import React from "react";
import { AutoSizer, List } from "react-virtualized";
import "react-virtualized/styles.css";

const BeneficiaryTable = ({ beneficios, isLoadingSend }) => {
  const rowRenderer = ({ index, key, style }) => {
    const item = beneficios[index];

    return (
      <div
        key={key}
        style={style}
        className="flex border-b border-gray-200 bg-white px-6 py-3 text-sm text-gray-500 rounded-b-xl"
      >
        <div className="w-full flex">
          <div className="w-1/5 min-w-[150px]">{item.matricula}</div>
          <div className="w-1/5 min-w-[150px]">{item.dateOfBirth}</div>
          <div className="w-1/5 min-w-[150px]">{item.gender}</div>
          <div className="w-1/5 min-w-[150px]">{item.city}</div>
          <div className="w-1/5 min-w-[150px]">{item.state}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full flex flex-col items-center justify-between px-0.5 overflow-y-auto bg-gray-50
      [&::-webkit-scrollbar]:w-2
      [&::-webkit-scrollbar-track]:rounded-full
      [&::-webkit-scrollbar-track]:bg-gray-100
      [&::-webkit-scrollbar-thumb]:rounded-full
      [&::-webkit-scrollbar-thumb]:bg-gray-300">

      <div className='w-full flex justify-center'>
        <div className="w-[1096px] h-[240px] border border-gray-200 rounded-xl">
          {beneficios && (
            <AutoSizer>
              {({ height, width }) => (
                <div style={{ width, height }}>
                  <div className='overflow-x-auto'>
                    <div className="w-full flex sticky top-0 bg-gray-50 text-xs font-medium text-gray-500 uppercase px-6 py-3 rounded-t-xl">
                      <div className="w-[208px] min-w-[208px]">Matrícula</div>
                      <div className="w-[208px] min-w-[208px]">Data de Nascimento</div>
                      <div className="w-[208px] min-w-[208px]">Gênero</div>
                      <div className="w-[208px] min-w-[208px]">Cidade</div>
                      <div className="w-[208px] min-w-[208px]">Estado</div>
                    </div>

                    <List
                      width={1094}
                      height={height - 40}
                      rowHeight={40}
                      rowCount={beneficios.length}
                      rowRenderer={rowRenderer}
                      overscanRowCount={5}
                    />
                  </div>
                </div>
              )}
            </AutoSizer>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-3 justify-center md:relative md:justify-start mt-4">
        {isLoadingSend && (
          <div className="flex justify-center items-center gap-3">
            <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-l-2 border-gray-700" /><span> Carregando...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BeneficiaryTable;
